import { jsx as _jsx } from "react/jsx-runtime";
import Button from "@components/button/Button";
import WidgetWrapper from "@components/wrapper/WidgetWrapper";
import cn from "classnames";
const ButtonWidget = ({ bottomMargin, theme, topMargin, widgetID, text, link, target, type, download, buttonSide }) => {
    const getJustifyValue = () => {
        // if buttonSide is left or undefined default to justify start
        if (!buttonSide || (!!buttonSide && buttonSide === "left")) {
            return "ltr:justify-start rtl:justify-end";
        }
        else if (buttonSide === "right") {
            return "ltr:justify-end rtl:justify-start";
        }
        else {
            return "justify-center";
        }
    };
    return (_jsx(WidgetWrapper, { id: widgetID, bottomMargin: bottomMargin, topMargin: topMargin, theme: theme, className: cn("button-widget", `${getJustifyValue()}`), children: _jsx(Button, { title: text, link: link, target: target, type: type, download: download }) }));
};
export default ButtonWidget;
